export const resolutionError = 'Aggregator/Payer combination not found';

export const resolutionListHeaders = [
  { header: 'resolutionCode', label: 'RESOLUTION CODE' },
  { header: 'description', label: 'DESCRIPTION' },
  { header: 'alertType', label: 'ALERT TYPE' },
];
